import { render, staticRenderFns } from "./ApartmentsOverview.vue?vue&type=template&id=50a65e98&scoped=true"
import script from "./ApartmentsOverview.vue?vue&type=script&lang=js"
export * from "./ApartmentsOverview.vue?vue&type=script&lang=js"
import style0 from "./ApartmentsOverview.vue?vue&type=style&index=0&id=50a65e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a65e98",
  null
  
)

export default component.exports